import React, { useState, useEffect } from 'react';
import { GatsbyImage } from "gatsby-plugin-image";

import { FaPlay } from 'react-icons/fa';

import './video.scss';
export default ({ props }) => {
  const [data, setData] = useState(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setData({
      video: {
        youtube: props.field_youtube,
      },
      img: props.relationships.field_poster
        ? {
            src: props.relationships.field_poster.relationships
              .field_media_image.localFile,
            alt: props.relationships.field_poster.field_media_image
              .alt,
          }
        : null,
    });
  }, [props.field_youtube, props.relationships.field_poster]);

  if (data) {
    return (
      <div className={`p-video`}>
        {data.img && data.img.src.childImageSharp && (
          <>
            <GatsbyImage
              image={{ ...data.img.src.childImageSharp.gatsbyImageData }}
              alt={data.img.alt}
              imgStyle={{ objectFit: 'contain' }} />
            <button
              onClick={() => setIsActive(true)}
              className={'btn btn-clean'}
              aria-label="play"
            >
              <FaPlay />
            </button>
          </>
        )}
        {isActive && (
          <div className={`activated`}>
            <iframe
              style={{ padding: '15px 0' }}
              title="video"
              width="100%"
              height="100%"
              src={`https://www.youtube-nocookie.com/embed/${
                props.field_youtube.split('watch?v=')[1]
              }?autoplay=1`}
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture;"
              allowFullScreen
            ></iframe>
          </div>
        )}
        {!data.img && (
          <>
            <iframe
              style={{ padding: '15px 0' }}
              title="video"
              width="100%"
              height="320"
              src={`https://www.youtube-nocookie.com/embed/${
                props.field_youtube.split('watch?v=')[1]
              }?autoplay=0`}
              frameBorder="0"
              allow="encrypted-media; picture-in-picture;"
              allowFullScreen
            ></iframe>
          </>
        )}
      </div>
    );
  } else {
    return null;
  }
};
